import { Avatar, Box, Typography } from "@mui/material";

const CurrentUser = ({ displayName, photoURL, role, email }) => {
  return (
    <>
      <Box sx={{ pb: 6 }}>
        <Box
          sx={{
            alignItems: "center",
            display: "flex",
            mt: 5,
          }}
        >
          <Avatar
            src={photoURL}
            sx={{
              height: 64,
              width: 64,
            }}
          />
          <Box sx={{ ml: 2 }}>
            <Typography variant="h6">
              {displayName} ({role})
            </Typography>
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default CurrentUser;
